module.exports = __webpack_public_path__ + "static/img/alipay.f8420a2b.png";